import { Component, OnInit, ViewChild } from '@angular/core';
import { Plano } from '../../shared/models/plano.model';
import { WebIntegrPerfilADO } from '../../shared/models/webIntegrPerfilADO.model';
import { WebIntegrFuncionalidadeADO } from '../../shared/models/webIntegrFuncionalidadeADO.model';
import { PlanoService } from '../../shared/services/plano.service';
import { WebIntegrPerfilADOService } from '../../shared/services/webIntegrPerfilADO.service';
import { WebIntegrFuncionalidadeADOService } from '../../shared/services/webIntegrFuncionalidadeADO.service';
import { MatDialog, MatPaginator, MatSnackBar, MatSort, MatTableDataSource } from '@angular/material';
import { WebConfigFuncionalidadeRotinaService } from '../../shared/services/webConfigFuncionalidadeRotina.service';
import { WebConfigFuncionalidadeRotinaResponse } from '../../shared/models/webConfigFuncionalidadeRotinaResponse.model';
import { InsertDialogMensagemFuncionalidadeComponent } from './dialogs/insert/insert.dialog.component';
import { EditDialogMensagemFuncionalidadeComponent } from './dialogs/edit/edit.dialog.component';
import { DeleteDialogMensagemFuncionalidadeComponent } from './dialogs/delete/delete.dialog.component';


export interface PeriodicElement {
    categoria: string;
    plano: number;
    funcionalidade: string;
  }
  const ELEMENT_DATA: PeriodicElement[] = [
    {categoria: 'Teste', plano: 1234455555, funcionalidade: 'gdyegd'},
    {categoria: 'Teste', plano: 1234455555, funcionalidade: 'werbde dherrtt'},
    {categoria: 'Teste', plano: 1234455555, funcionalidade: 'werrdedertt'}
  
    ];
@Component({
  selector: 'app-config-mensagem-funcionalidade',
  templateUrl: './config-mensagem-funcionalidade.component.html',
  styleUrls: ['./config-mensagem-funcionalidade.component.scss']
})
export class ConfigMensagemFuncionalidadeComponent implements OnInit {
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    
    displayedColumns: string[] = ['categoria', 'plano', 'funcionalidade', 'acoes'];
    dataSource = new MatTableDataSource<any>();
    
    listaPlano: Plano[] = [];
    listaPerfil: WebIntegrPerfilADO[] = [];
    listaFuncionalidade: WebIntegrFuncionalidadeADO[] = [];

    selectedPerfil: number;
    selectedPlano: number;
    selectedFuncionalidade: number;

    loading = false;

  constructor(
    public dialog: MatDialog,
    private planoService: PlanoService,
    private webIntegrPerfilADOService: WebIntegrPerfilADOService,
    private webIntegrFuncionalidadeADOService: WebIntegrFuncionalidadeADOService,
    private webConfigFuncionalidadeRotinaService: WebConfigFuncionalidadeRotinaService,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.planoService.getAll().subscribe(obj => this.listaPlano = obj);
    this.webIntegrPerfilADOService.getAll().subscribe(obj => this.listaPerfil = obj);
    this.webIntegrFuncionalidadeADOService.getAll().subscribe(obj => this.listaFuncionalidade = obj);
  }
  buscar() {
    this.loading = true;
    console.log('teste')
    this.webConfigFuncionalidadeRotinaService.RetornarPor(this.selectedPerfil, this.selectedPlano, this.selectedFuncionalidade).subscribe(obj => {
      
      this.dataSource = new MatTableDataSource<WebConfigFuncionalidadeRotinaResponse>(obj);
      this.dataSource.paginator = this.paginator;
      this.refreshTable();
  
        this.loading = false;
    });
}
limpar() {
    this.selectedPerfil = undefined;
    this.selectedPlano = undefined;
    this.selectedFuncionalidade = undefined;
  }


  insertNew() {
    const dialogRef = this.dialog.open(InsertDialogMensagemFuncionalidadeComponent, {
        width:'70%',
        height:'75%',
        
      data: { WebConfigFuncionalidadeRotinaResponse : WebConfigFuncionalidadeRotinaResponse}
    });
    
    dialogRef.afterClosed().subscribe(result => {
        if (result === 1) {
            this.loading = true;
          this.webConfigFuncionalidadeRotinaService.Inserir(this.webConfigFuncionalidadeRotinaService.getDialogData()).subscribe(listInsert => {
            console.log(listInsert)
            this.webConfigFuncionalidadeRotinaService.RetornarPor(0,0,0).subscribe(obj => {
              this.dataSource = new MatTableDataSource<WebConfigFuncionalidadeRotinaResponse>(obj);
              this.dataSource.paginator = this.paginator;

              this._snackBar.open('Mensagem Cadastrada com sucesso', 'X', {
                duration: 30000,
                panelClass: ['red-snackbar']
            })
            });
            this.loading = false;
          });
  
        }
      });
    }
    startEdit( element : any) {
        console.log(element)
        const dialogRef = this.dialog.open(EditDialogMensagemFuncionalidadeComponent, {
            width:'70%',
            height:'75%',
          data: element

       
        });
        
        dialogRef.afterClosed().subscribe(result => {
            if (result === 1) {
                this.loading = true;
              // When using an edit things are little different, firstly we find record inside DataService by id
              this.webConfigFuncionalidadeRotinaService.Put(this.webConfigFuncionalidadeRotinaService.getDialogData()).subscribe(listUpdate => {
                console.log(listUpdate);
      
                this.webConfigFuncionalidadeRotinaService.RetornarPor(0,0,0).subscribe(obj => {
                    this.dataSource = new MatTableDataSource<WebConfigFuncionalidadeRotinaResponse>(obj);
                    this.dataSource.paginator = this.paginator;
                    this.refreshTable();
      
                    this._snackBar.open('Mensagem Editada com sucesso', 'X', {
                      duration: 30000,
                      panelClass: ['red-snackbar']
                  })
                  });
                  this.loading = false;
              });
      
            }
          });
    }
    deleteItem(data: WebConfigFuncionalidadeRotinaResponse) {
        const dialogRef = this.dialog.open(DeleteDialogMensagemFuncionalidadeComponent, {
            width:'70%',
            height:'65%',
          data
        });
    
        dialogRef.afterClosed().subscribe(result => {

          if (result === 1) {
            this.loading = true;
            this.webConfigFuncionalidadeRotinaService.deletar(data.idConfigFuncRotina).subscribe(listDelete => {
              console.log(listDelete);
              this.webConfigFuncionalidadeRotinaService.RetornarPor(0,0,0).subscribe(obj => {
                this.dataSource = new MatTableDataSource<WebConfigFuncionalidadeRotinaResponse>(obj);
                this.dataSource.paginator = this.paginator;
                this.refreshTable();
                this._snackBar.open('Excluido com sucesso', 'X', {
                    duration: 30000,
                    panelClass: ['red-snackbar']
                })
              });
              this.loading = false;
            });
    
          }
        });
      }

    private refreshTable() {
        this.paginator._changePageSize(this.paginator.pageSize);
      }
}
